/** Fills the `{{membershipId}}` / `{{groupId}}` placeholders in sidebar copy. */
export const insertMemberIds = (params: {
  text: string;
  memberNumber?: string;
  groupNumber?: string;
}): string =>
  params.text
    .replaceAll("{{membershipId}}", params.memberNumber || "---")
    .replaceAll("{{groupId}}", params.groupNumber || "---");
